/**
 * src/state/riskConflicts.js
 *
 * GH #7935 (TRYGGR_INTENT.md §13 d) — which of the clashes risks-write named
 * in a 409 FIELD_CONFLICT the user may overwrite with their own value.
 *
 * Same rule as the tenant blob's "keep mine" (src/state/patchConflicts.js,
 * CONC-01): only a plain field clash, and never a status-bearing field — a
 * status is changed from the record's own screen, where its rules run. The
 * server applies the identical rule (risks-write/handlers/update.js), so this
 * only decides whether the button is offered; it grants nothing.
 */
import { STATUS_BEARING_FIELDS } from '../../azure-functions/shared/state/statePatch.cjs';

export function keepableConflicts(conflicts) {
  if (!Array.isArray(conflicts)) return [];
  return conflicts.filter((c) => {
    if (!c || c.kind !== 'changed' || c.op || !Array.isArray(c.path) || !c.path.length)
      return false;
    const last = c.path[c.path.length - 1];
    return !(typeof last === 'string' && STATUS_BEARING_FIELDS.has(last));
  });
}
